import React from "react";
import { Modal, Button } from "antd";
import { ExclamationOutlined } from "@ant-design/icons";

type PortalActiveInActiveModalProps = {
  open: boolean;
  onClose: () => void;
};

const PortalActiveInActiveModal: React.FC<PortalActiveInActiveModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      centered
      closable={false}
      maskClosable={false}
      width={460}
      zIndex={2500}
      footer={
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            onClick={onClose}
            style={{
              minWidth: 100,
              backgroundColor: "#faad14",
              borderColor: "#faad14",
              fontWeight: 600,
            }}
          >
            OK
          </Button>
        </div>
      }
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          padding: "8px 0",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 52,
            height: 52,
            borderRadius: "50%",
            border: "2px solid #faad14",
            boxShadow: "0 0 12px #faad1466",
            marginBottom: 16,
          }}
        >
          <ExclamationOutlined style={{ fontSize: 24, color: "#faad14" }} />
        </div>
        <div
          style={{
            fontWeight: 700,
            fontSize: 18,
            marginBottom: 8,
            textTransform: "uppercase",
          }}
        >
          Warning
        </div>
        <div style={{ fontSize: 16, fontWeight: 500, color: "#595959" }}>
          The portal is inactive. Please log in again.
        </div>
      </div>
    </Modal>
  );
};

export default PortalActiveInActiveModal;
